import { ReactNode, useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { icons } from '../../../../../utils/icons'
import SimpleModal from '../../../../../components/modal/simpleModal'
import { useStyles } from './configLayout.styles'

interface ConfigLayoutProps {
  title: string
  subtitle: string
  children: ReactNode
  onBack: () => void
  onSave: () => void
  saveDisabled?: boolean
  saveLabel?: string
  backLabel?: string
  headerActions?: ReactNode
}

const ConfigLayout = ({
  title,
  subtitle,
  children,
  onBack,
  onSave,
  saveDisabled = false,
  saveLabel,
  backLabel,
  headerActions,
}: ConfigLayoutProps) => {
  const { t } = useTranslation()
  const styles = useStyles()
  const [openConfirm, setOpenConfirm] = useState(false)

  const handleOpenConfirm = () => setOpenConfirm(true)
  const handleCloseConfirm = () => setOpenConfirm(false)
  const handleConfirm = () => {
    onSave()
    setOpenConfirm(false)
  }

  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Box sx={styles.headerText}>
          <Typography sx={styles.title}>{title}</Typography>
          <Typography sx={styles.subtitle}>{subtitle}</Typography>
        </Box>
        {headerActions && <Box sx={styles.headerActions}>{headerActions}</Box>}
      </Box>

      <Box sx={styles.content}>{children}</Box>

      <Box sx={styles.footer}>
        <Button
          variant='text'
          startIcon={icons('arrow-left-fill')}
          onClick={onBack}
          sx={styles.backButton}
        >
          {backLabel}
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={handleOpenConfirm}
          disabled={saveDisabled}
          sx={styles.saveButton}
        >
          {saveLabel}
        </Button>
      </Box>

      <SimpleModal
        open={openConfirm}
        close={handleCloseConfirm}
        back={handleCloseConfirm}
        next={handleConfirm}
        title={t('actionPlan.manualCreation.confirmConfiguration.title')}
        buttonText={t('actionPlan.manualCreation.confirmConfiguration.confirm')}
        cancelText={t('actionPlan.manualCreation.confirmConfiguration.cancel')}
        sx={styles.modalConfirmation}
      />
    </Box>
  )
}

export default ConfigLayout
